import { NavigationMenuItem } from 'app/interfaces/sidebar';
import { useRoles } from 'modules/auth/hooks';
import { useMemo } from 'react';
import { Route } from 'app/enums';
import plusIcon from 'assets/images/plus_icon.svg';
import { Role } from '@okletsplay/core';
import hatIcon from 'assets/images/hat_icon.svg';
import usersIcon from 'assets/images/users_icon.svg';
import atmIcon from 'assets/images/atm_icon.svg';
import RedeemIcon from '@mui/icons-material/Redeem';
import { useNavigate } from 'react-router-dom';

interface AdminMenuItemsHook {
  adminMenuItems: NavigationMenuItem[];
}

export function useAdminMenuItems(): AdminMenuItemsHook {
  const { hasAllRoles } = useRoles();
  const navigate = useNavigate();

  const adminMenuItems = useMemo((): NavigationMenuItem[] => {
    const menuItems: NavigationMenuItem[] = [
      {
        label: 'Create Tournament',
        onClick: () => navigate(Route.CreateTournament),
        route: Route.CreateTournament,
        icon: plusIcon,
        roles: [Role.User, Role.TournamentCreator],
      },
      {
        label: 'Manage Tournaments',
        onClick: () => navigate(Route.AdminManageTournaments),
        route: Route.AdminManageTournaments,
        icon: hatIcon,
        roles: [Role.User, Role.TournamentAdministrator],
      },
      {
        label: 'Manage Users',
        onClick: () => navigate(Route.AdminManageUsers),
        route: Route.AdminManageUsers,
        icon: usersIcon,
        roles: [Role.User, Role.UserAdministrator],
      },
      {
        route: Route.AdminWithdrawRequests,
        onClick: () => navigate(Route.AdminWithdrawRequests),
        label: 'Withdraw Requests',
        icon: atmIcon,
        roles: [Role.User, Role.PaymentAdministrator],
      },
      {
        route: Route.ManageAffiliatePrograms,
        onClick: () => navigate(Route.ManageAffiliatePrograms),
        label: 'Manage Affiliate Programs',
        icon: RedeemIcon,
        roles: [Role.User, Role.AffiliateProgramAdmin],
      },
    ];

    return menuItems.filter((item) => hasAllRoles(item?.roles ?? []));
  }, [hasAllRoles, navigate]);

  return { adminMenuItems };
}
